module.exports = {
      id: "cancel-usage",
      viewBox: "0 0 241.171 241.171",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#cancel",
      toString: function () {
        return this.url;
      }
    }